import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n';
import { useCookieConsent } from '../lib/cookieConsent';
import SocialLinks from './SocialLinks';

const Footer = () => {
  const { t } = useI18n();
  const { openSettings } = useCookieConsent();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#1E3A8A] text-white" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="font-brand text-2xl tracking-[0.32em]">VIDAT</div>
            <div className="text-[11px] uppercase tracking-[0.22em] text-white/70 mt-2">{t('brand.tagline')}</div>
            <p className="mt-8 text-sm text-white/80 leading-relaxed max-w-md font-light">
              {t('footer.tagline')}
            </p>
            <SocialLinks variant="dark" className="mt-8" testIdPrefix="footer-social" />
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.22em] text-white/60 mb-5">{t('footer.sections')}</div>
            <ul className="space-y-3 text-sm text-white/85 font-light">
              <li><Link to="/valoracion-cardiometabolica" className="hover:text-white">{t('nav.cardio')}</Link></li>
              <li><Link to="/valoracion-adiposidad-metabolismo" className="hover:text-white">{t('nav.adiposity')}</Link></li>
              <li><Link to="/valoracion-diabetes-tipo-2" className="hover:text-white">{t('nav.diabetes')}</Link></li>
              <li><Link to="/senior-saludable" className="hover:text-white">{t('nav.senior')}</Link></li>
              <li><Link to="/rehabilitacion-funcional" className="hover:text-white">{t('nav.rehab')}</Link></li>
              <li><Link to="/medicina-de-familia" className="hover:text-white">{t('nav.family')}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-[11px] uppercase tracking-[0.22em] text-white/60 mb-5">{t('footer.institute')}</div>
            <ul className="space-y-3 text-sm text-white/85 font-light">
              <li><Link to="/sobre-vidat" className="hover:text-white">{t('nav.about')}</Link></li>
              <li><Link to="/programar-visita" className="hover:text-white">{t('nav.book')}</Link></li>
              <li><a href="mailto:info@vidat.cat" className="hover:text-white" data-testid="footer-contact">Contacto</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-[11px] uppercase tracking-[0.22em] text-white/60 mb-5">Legal</div>
            <ul className="space-y-3 text-sm text-white/85 font-light">
              <li><Link to="/politica-de-privacidad" className="hover:text-white" data-testid="footer-privacy">Política de Privacidad</Link></li>
              <li><Link to="/politica-de-cookies" className="hover:text-white" data-testid="footer-cookies">Política de Cookies</Link></li>
              <li>
                <button
                  type="button"
                  onClick={openSettings}
                  className="hover:text-white text-left"
                  data-testid="footer-cookie-settings"
                >
                  Configurar cookies
                </button>
              </li>
              <li><Link to="/aviso-legal" className="hover:text-white" data-testid="footer-legal">Aviso Legal</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/15 grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="text-xs text-white/70 font-light leading-relaxed" data-testid="footer-legal-entity">
            VIDAT INSTITUTO DE INTELIGENCIA MEDICA, S.L.<br/>
            Local 6, Carrer de Pau Muñoz i Castanyer, 12<br/>
            08174 Sant Cugat del Vallès, Barcelona.<br/>
            <a href="mailto:info@vidat.cat" className="hover:text-white underline-offset-2 hover:underline">info@vidat.cat</a>
          </div>
          <div className="text-[11px] text-white/55 font-light leading-relaxed md:text-right">
            <div className="uppercase tracking-wider mb-2">© {year} VIDAT — {t('footer.rights')}</div>
            <div>{t('footer.notice')}</div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
